var exports = {
  "D": "PlayButton__2hF6Uw",
};

module.exports = exports;
